import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'
var fechaHoy = moment().format('YYYY-MM-DD');
/**DATOS INICIALES */
const dataInicial = {
    clientes: [],
    detalleCliente: {},
    fc01ConMap: [],
    relacionesCliente: [],
    file: [],
    historialFiles: [],
    cliente: []
}

const OBTENER_CLIENTES_EXITO = 'OBTENER_USUARIOS_ATENCION_A_CLIENTES_EXITO'
const OBTENER_CLIENTE_CON_DETALLE_EXITO = 'OBTENER_CLIENTE_CON_DETALLE_EXITO'
const OBTENER_CLIENTE_CON_DETALLE_EXITO_AT = 'OBTENER_CLIENTE_CON_DETALLE_EXITO_AT'
const OBTENER_DETALLE_FC_01_CON_MAPS_EXITO = 'OBTENER_DETALLE_FC_01_CON_MAPS_EXITO'
const OBTENER_FC_01_POR_LOGIN_EXITO = 'OBTENER_FC_01_POR_LOGIN_EXITO'
const OBTENER_TODAS_RELACIONES_CLIENTE_EXITO = 'OBTENER_TODAS_RELACIONES_CLIENTE_EXITO'
const AGREGAR_RELACIONES_CLIENTES_EXITO = 'AGREGAR_RELACIONES_CLIENTES_EXITO'
const OBTENER_ARCHIVO_CLIENTE_EXITO = 'OBTENER_ARCHIVO_CLIENTE_EXITO'
const ACTUALIZAR_ARCHIVO_CLIENTE_EXITO = 'ACTUALIZAR_ARCHIVO_CLIENTE_EXITO'
const AGREGAR_ARCHIVO_CLIENTE_EXITO = 'AGREGAR_ARCHIVO_CLIENTE_EXITO'
const AGREGAR_HISTORIAL_ARCHIVO_CLIENTES_EXITO = 'AGREGAR_HISTORIAL_ARCHIVO_CLIENTES_EXITO'
const ACTUALIZAR_ARCHIVO_CLIENTES_EXITO = 'ACTUALIZAR_ARCHIVO_CLIENTES_EXITO'
const OBTENER_HISTORIAL_ARCHIVOS_CLIENTES_EXITO = 'OBTENER_HISTORIAL_ARCHIVOS_CLIENTES_EXITO'
const ACTUALIZAR_CLIENTES_EXITO = 'ACTUALIZAR_CLIENTES_EXITO'
const ACTUALIZAR_MEDIO_CONTACTO_CLIENTE_EXITO = 'ACTUALIZAR_MEDIO_CONTACTO_CLIENTE_EXITO'
const ACTUALIZAR_APODERADOS_CLIENTE_EXITO = 'ACTUALIZAR_APODERADOS_CLIENTE_EXITO'
const ACTUALIZAR_PERSOPNAS_AUTORIZADAS_CLIENTE_EXITO = 'ACTUALIZAR_PERSOPNAS_AUTORIZADAS_CLIENTE_EXITO'
const ACTUALIZAR_DOMICILIOS_CLIENTE_EXITO = 'ACTUALIZAR_DOMICILIOS_CLIENTE_EXITO'
const ACTUALIZAR_MARCAS_MEZCAL_CLIENTE_EXITO = 'ACTUALIZAR_MARCAS_MEZCAL_CLIENTE_EXITO'
const ACTUALIZAR_MARCAS_BEBIDAS_CLIENTE_EXITO = 'ACTUALIZAR_MARCAS_BEBIDAS_CLIENTE_EXITO'
const OBTENER_DOMICILIOS_CLIENTE_EXITO = 'OBTENER_DOMICILIOS_CLIENTE_EXITO'
const OBTENER_MARCAS_MEZCAL_CLIENTE_EXITO = 'OBTENER_MARCAS_MEZCAL_CLIENTE_EXITO'
const OBTENER_MARCAS_BEBIDAS_CLIENTE_EXITO = 'OBTENER_MARCAS_BEBIDAS_CLIENTE_EXITO'
const OBTENER_TODAS_RELACIONES_PRODUCTOR_CLIENTE_EXITO = 'OBTENER_TODAS_RELACIONES_PRODUCTOR_CLIENTE_EXITO'
const OBTENER_TODAS_RELACIONES_MAQUILADOR_CLIENTE_EXITO = 'OBTENER_TODAS_RELACIONES_MAQUILADOR_CLIENTE_EXITO'
const ACTUALIZAR_RELACIONES_CLIENTES_EXITO = 'ACTUALIZAR_RELACIONES_CLIENTES_EXITO'
const ELIMINAR_RELACIONES_CLIENTES_EXITO = 'ELIMINAR_RELACIONES_CLIENTES_EXITO'
const ACTUALIZAR_INSTALACIONES_CLIENTE_EXITO = 'ACTUALIZAR_INSTALACIONES_CLIENTE_EXITO'
const OBTENER_TODAS_INSTALACIONES_CLIENTE_EXITO = 'OBTENER_TODAS_INSTALACIONES_CLIENTE_EXITO'
const OBTENER_TODAS_MEDIOS_CONTACTO_CLIENTE_EXITO = 'OBTENER_TODAS_MEDIOS_CONTACTO_CLIENTE_EXITO'
const OBTENER_TODAS_APODERADOS_LEGALES_CLIENTE_EXITO = 'OBTENER_TODAS_APODERADOS_LEGALES_CLIENTE_EXITO'
const OBTENER_TODOS_PERSONAS_AUTORIZADAS_CLIENTE_EXITO = 'OBTENER_TODOS_PERSONAS_AUTORIZADAS_CLIENTE_EXITO'
const OBTENER_CLIENTE_EXITO = 'OBTENER_CLIENTE_EXITO'
const ACTUALIZAR_PREDIOS_CLIENTE_EXITO = 'ACTUALIZAR_PREDIOS_CLIENTE_EXITO'
const ACTUALIZAR_VIVEROS_CLIENTE_EXITO = 'ACTUALIZAR_VIVEROS_CLIENTE_EXITO'
const OBTENER_TODOS_PREDIOS_CLIENTE_EXITO = 'OBTENER_TODOS_PREDIOS_CLIENTE_EXITO'
const OBTENER_TODOS_VIVEROS_CLIENTE_EXITO = 'OBTENER_TODOS_VIVEROS_CLIENTE_EXITO'
const OBTENER_FOLIO_OFICIO_EXITO = 'OBTENER_FOLIO_OFICIO_EXITO'
const GENERAR_OFICIOS_ACTUALIZAR_EXITO = 'GENERAR_OFICIOS_ACTUALIZAR_EXITO'
const ACTUALIZAR_FOLIO_CLIENTE_OFICIO = 'ACTUALIZAR_FOLIO_CLIENTE_OFICIO'

export const ObtenerClientes = createAsyncThunk(
    OBTENER_CLIENTES_EXITO,
    async () => {
        try {
            const fullUrl = host + `InformacionValida/obtenerTodosLosClientesConsulta`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerClienteConDetalle = createAsyncThunk(
    OBTENER_CLIENTE_CON_DETALLE_EXITO_AT,
    async (id) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClienteConDetalle/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerClienteConDetalleByNumeroSocio = createAsyncThunk(

    OBTENER_CLIENTE_CON_DETALLE_EXITO,
    async (numeroSocio) => {
        try {
            //alert('LLegué al duck');
            const fullUrl = host + `InformacionValida/obtenerClienteConDetalleByNumeroSocio/${numeroSocio}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerFC_01PorLogin = createAsyncThunk(
    OBTENER_FC_01_POR_LOGIN_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_01/obtenerFC_01PorLogin/${idSolicitud}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerSolicitudDetalleFC_01ConMaps = createAsyncThunk(
    OBTENER_DETALLE_FC_01_CON_MAPS_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_01/obtenerSolicitudFC_01DetalleConMaps/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodasLasRelacionesClientes = createAsyncThunk(
    OBTENER_TODAS_RELACIONES_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerTodasLasRelacionesClientes/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarRelacionesCliente = createAsyncThunk(
    AGREGAR_RELACIONES_CLIENTES_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/agregarNuevaRelacion'
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarRelacionesCliente = createAsyncThunk(
    ACTUALIZAR_RELACIONES_CLIENTES_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'AtencionAClientes/actualizarRelacion'
            const res = await axios.put(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarRelacionesCliente = createAsyncThunk(
    ELIMINAR_RELACIONES_CLIENTES_EXITO,
    async (idrelacionclientes) => {
        try {
            const fullUrl = host + `AtencionAClientes/eliminarRelacion/${idrelacionclientes}`
            await axios.delete(fullUrl)
            return fullUrl
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerArchivos = createAsyncThunk(
    OBTENER_ARCHIVO_CLIENTE_EXITO,
    async (data) => {
        try {
            //console.log("la data que lega es ", data)
            const fullUrl = host + `InformacionValida/obtenerArchivos/tabla=${data.tabla}&nombreId=${data.nombreid}&idSolicitud=${data.id}&nameid=${data.nameid}`
            const res = await axios.get(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarFileCliente = createAsyncThunk(
    AGREGAR_ARCHIVO_CLIENTE_EXITO,
    async (data) => {
        try {

            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}

export const actualizarFileCliente = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_CLIENTE_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}

export const agregarHistorialArchivosCliente = createAsyncThunk(
    AGREGAR_HISTORIAL_ARCHIVO_CLIENTES_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/agregarHistorialArchivo'
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarDatosFilesCliente = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_CLIENTES_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarDatosFilesCliente'
            const res = await axios.put(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaCliente = createAsyncThunk(
    ACTUALIZAR_CLIENTES_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialCliente'
            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodoHistorialCliente = createAsyncThunk(
    OBTENER_HISTORIAL_ARCHIVOS_CLIENTES_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerTodoHistorialCliente/id=${data.idSolicitud}&tabla=${data.tabla}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizaMedioContactoCliente = createAsyncThunk(
    ACTUALIZAR_MEDIO_CONTACTO_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarMediosDeContactoCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialMediosContactoCliente'
            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaApoderadosCliente = createAsyncThunk(
    ACTUALIZAR_APODERADOS_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarApoderadosLegalesCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialApoderadosLegalesCliente'

            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaPersonasAutorizadasCliente = createAsyncThunk(
    ACTUALIZAR_PERSOPNAS_AUTORIZADAS_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarRepresentantesAutorizadosCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialPersonasAutorizadasCliente'

            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaDomiciliosCliente = createAsyncThunk(
    ACTUALIZAR_DOMICILIOS_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarDomicilioFiscalCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialDomiciliosCliente'

            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaPrediosCliente = createAsyncThunk(
    ACTUALIZAR_PREDIOS_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarPredioCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialPredioCliente'

            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaVivierosCliente = createAsyncThunk(
    ACTUALIZAR_VIVEROS_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarViveroCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialViveroCliente'

            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaMarcaMezcalCliente = createAsyncThunk(
    ACTUALIZAR_MARCAS_MEZCAL_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarMarcasCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialMarcasMezcalCliente'

            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaMarcaBebidasMezcalCliente = createAsyncThunk(
    ACTUALIZAR_MARCAS_BEBIDAS_CLIENTE_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'InformacionValida/actualizarMarcasProductoConMezcalCliente'
            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialMarcasBebidasCliente'

            const res = await axios.put(fullUrl, { data: data.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: data })

            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizaInstalacionesCliente = createAsyncThunk(
    ACTUALIZAR_INSTALACIONES_CLIENTE_EXITO,
    async (data) => {
        try {
            let { dataActualizar, responsablesLegales, usuariocambio } = data
            let fechainscripcion = new Date(fechaHoy).toISOString()
            const fullUrl = host + 'InformacionValida/actualizarInformacionGeneralInstalacionCliente'
            const fullUrlResponsables = host + 'InformacionValida/actualizarResponsablesDeInstalacionCliente'

            const fullUrlHistorial = host + 'ModuloConsulta/agregarHistorialInformacionInstalacionCliente'
            const fullUrlResponsablesHistorial = host + 'ModuloConsulta/agregarHistorialResponsableInstalacionCliente'
            dataActualizar.fechacambio = fechainscripcion
            const res = await axios.put(fullUrl, { data: dataActualizar.datacambio })
            const resHistorial = await axios.post(fullUrlHistorial, { data: dataActualizar })

            for (const i in responsablesLegales) {
                if (responsablesLegales?.[i]?.isbaja == false) {
                    let responsable = {
                        datacambio: {
                            nombreresponsable: responsablesLegales?.[i].nombreresponsable, telefono: responsablesLegales?.[i].telefono,
                            correoelectronico: responsablesLegales?.[i].correoelectronico?.toLowerCase(), idresponsabledeinstalacioncliente: responsablesLegales?.[i].idresponsabledeinstalacioncliente
                        },
                        idresponsabledeinstalacioncliente: responsablesLegales?.[i].idresponsabledeinstalacioncliente, usuariocambio: usuariocambio,
                        fechacambio: fechainscripcion
                    }
                    await axios.put(fullUrlResponsables, { data: responsable.datacambio })
                    await axios.post(fullUrlResponsablesHistorial, { data: responsable })
                }
            }
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)


export const obtenerDomiciliosCliente = createAsyncThunk(
    OBTENER_DOMICILIOS_CLIENTE_EXITO,
    async (idcliente) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerTodosDomicilio/${idcliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerMarcasMezcalCliente = createAsyncThunk(
    OBTENER_MARCAS_MEZCAL_CLIENTE_EXITO,
    async (idcliente) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerTodosMarcasCliente/${idcliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerMarcasBebidasCliente = createAsyncThunk(
    OBTENER_MARCAS_BEBIDAS_CLIENTE_EXITO,
    async (idcliente) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerTodosMarcasMezcalCliente/${idcliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerTodasLasRelacionesProductorClientes = createAsyncThunk(
    OBTENER_TODAS_RELACIONES_PRODUCTOR_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `AtencionAClientes/obtenerTodasLasRelacionesProductorClientes/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerTodasLasRelacionesMaquiladorClientes = createAsyncThunk(
    OBTENER_TODAS_RELACIONES_MAQUILADOR_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `AtencionAClientes/obtenerTodasLasRelacionesMaquiladorClientes/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerTodasLasInstalacionesClientes = createAsyncThunk(
    OBTENER_TODAS_INSTALACIONES_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerTodasLasInstalacionesClientes/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerTodosMediosContactoClientes = createAsyncThunk(
    OBTENER_TODAS_MEDIOS_CONTACTO_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerMediosDeContactobyCliente/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerTodosApoderadosLegalesClientes = createAsyncThunk(
    OBTENER_TODAS_APODERADOS_LEGALES_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerApoderadosLegalesbyCliente/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerTodosPersonasAutorizadasClientes = createAsyncThunk(
    OBTENER_TODOS_PERSONAS_AUTORIZADAS_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerPersonasAutorizadasbyCliente/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerCliente = createAsyncThunk(
    OBTENER_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerCliente/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerTodosPrediosClientes = createAsyncThunk(
    OBTENER_TODOS_PREDIOS_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerPrediobyCliente/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerTodosViverosClientes = createAsyncThunk(
    OBTENER_TODOS_VIVEROS_CLIENTE_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloConsulta/obtenerVivierobyCliente/${id}`;
            const res = await axios.get(fullUrl);
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerFolioConsulta = createAsyncThunk(
    OBTENER_FOLIO_OFICIO_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `AtencionAClientes/obtenerFolioOficio/${idSolicitud}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const generarOficiosClienteConsulta = createAsyncThunk(
    GENERAR_OFICIOS_ACTUALIZAR_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'ModuloConsulta/generarOficiosActualizar'
            const result = await axios.post(fullUrl, data)
            return {}
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFolioOficio = createAsyncThunk(
    ACTUALIZAR_FOLIO_CLIENTE_OFICIO,
    async (data) => {
        try {
            const fullUrl = host + `AtencionAClientes/actualizarFolioOficio`
            const res = await axios.post(fullUrl, data)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const ModuloConsultaSlice = createSlice({
    initialState: dataInicial,
    name: 'InspectorSlice',
    reducers: {
    },
    extraReducers: {
        [ObtenerClientes.fulfilled]: (state, { payload }) => {
            state.clientes = payload
        },
        [obtenerClienteConDetalle.fulfilled]: (state, { payload }) => {
            state.detalleCliente = payload
        },
        [obtenerSolicitudDetalleFC_01ConMaps.fulfilled]: (state, { payload }) => {
            state.fc01ConMap = payload
        },
        [obtenerTodasLasRelacionesClientes.fulfilled]: (state, { payload }) => {
            state.relacionesCliente = payload
        },
        [obtenerArchivos.fulfilled]: (state, { payload }) => {
            state.file = payload
        },
        [agregarHistorialArchivosCliente.fulfilled]: (state, { payload }) => {
        },
        /*[obtenerTodoHistorialCliente.fulfilled]: (state, { payload }) => {
            state.historialFiles = payload
        },*/
        [obtenerClienteConDetalleByNumeroSocio.fulfilled]: (state, { payload }) => {
            state.cliente = payload
        },

    },
})

export const {
} = ModuloConsultaSlice.actions

export const ModuloConsultaReducer = ModuloConsultaSlice.reducer